<div cdkDrag [cdkDragDisabled]="!modalDragOn" cdkDragRootElement=".modal-content" class="seriesTypeModal">
    <div style="background-color: #548235; height: 7px;"></div>
    <div class="modal-header" (mouseenter)="setDragOn(true)" (mouseleave)="setDragOn(false)"
         style="background-color: #a9d18e; height: 50px; padding-top: 20px; border-radius: 0px;">
        <h5 style="color: rgb(10, 10, 10); text-transform: none;">Chart Type per Series</h5>
    </div>

    <div class="modal-body" style="margin-top: -1px; padding: 15px;">
        <div class="series-rows">
            <div *ngFor="let row of rows; let i = index" class="series-row">
                <span class="swatch" [style.background-color]="row.color"></span>
                <span class="series-name" [title]="row.name">{{ row.name }}</span>
                <select class="form-control form-control-sm series-select" [(ngModel)]="row.type" name="{{'SeriesType' + i}}">
                    <option value="">Default ({{ defaultTypeLabel }})</option>
                    <option *ngFor="let t of types" [value]="t.value">{{ t.label }}</option>
                </select>
            </div>
        </div>

        <small class="text-muted">Series set to Default follow the Chart Type dropdown. Running Sum lines are not listed; they always draw as dashed lines.</small>

        <div style="margin-top: 15px; display: flex; gap: 8px; align-items: center;">
            <button type="button" class="btn btn-success" (click)="apply()">Apply</button>
            <button type="button" class="btn btn-outline-secondary" (click)="resetAll()">Reset all</button>
            <button type="button" class="btn btn-basic" style="margin-left: auto;" (click)="cancel()">Cancel</button>
        </div>
    </div>
</div>
